export var TeamApiEndpoint;
(function (TeamApiEndpoint) {
    TeamApiEndpoint["GetAllTeams"] = "";
    TeamApiEndpoint["GetOverview"] = "overview/";
    TeamApiEndpoint["Create"] = "create/";
})(TeamApiEndpoint || (TeamApiEndpoint = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGVhbS5hcGktZW5kcG9pbnQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJ0ZWFtLmFwaS1lbmRwb2ludC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxNQUFNLENBQU4sSUFBWSxlQUlYO0FBSkQsV0FBWSxlQUFlO0lBQ3ZCLG1DQUFnQixDQUFBO0lBQ2hCLDRDQUF5QixDQUFBO0lBQ3pCLHFDQUFrQixDQUFBO0FBQ3RCLENBQUMsRUFKVyxlQUFlLEtBQWYsZUFBZSxRQUkxQiJ9